const DEVICE_STORAGE_KEY = 'kg_web_client_device_id'
let memoryDeviceId = ''

// 浏览器实例标识用于同设备规则；不是硬件序列号，清理存储后会重新生成。
export function getClientDeviceId() {
  if (memoryDeviceId) return memoryDeviceId
  try {
    const saved = localStorage.getItem(DEVICE_STORAGE_KEY)
    if (typeof saved === 'string' && /^web-[a-zA-Z0-9-]{16,80}$/.test(saved)) {
      memoryDeviceId = saved
      return saved
    }
  } catch (_) { /* 存储不可用时沿用本页面内存标识。 */ }
  const randomId = globalThis.crypto?.randomUUID?.() || `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`
  memoryDeviceId = `web-${randomId}`
  try { localStorage.setItem(DEVICE_STORAGE_KEY, memoryDeviceId) } catch (_) { /* 同上。 */ }
  return memoryDeviceId
}
